module.exports = __webpack_public_path__ + "img/building-sketch-footing.d28b1a51.svg";